import linkUtils, { getCommunityLogoUrl } from 'src/utils/linkUtils';
import { truncate } from 'underscore.string';

const standardNotificationMenuItem = (notification, args) => (
  <div>
    <span style={{fontWeight: 600}}>{args.username}</span>
    {` ${notification.actionVerb} `}
    <span style={{fontWeight: 600}}>{args.title}</span>
  </div>
);

const customNotificationMenuItem = (notification) => (
  <div>
    {notification.text}
  </div>
);

function menuItem(notification, args) {
  switch (notification.activityType) {
    case 'custom-notification':
      return customNotificationMenuItem(notification);
    default:
      return standardNotificationMenuItem(notification, args);
  }
}

function userImageUrl(notification, user) {
  switch (notification.activityType) {
    case 'custom-notification':
      return getCommunityLogoUrl('blog');
    default:
      return linkUtils.generateAvatarLink(user);
  }
}

export const notificationToMenuItemConfig = (notifications, unread) => {
  return notifications.length === 0 ? [] : notifications.map((notification, i) => {
    const user = notification.user || { username: '', email: '' };
    const username = user.username;
    const link = notification.link || `/user/${username.toLowerCase()}`;
    const imageUrl = userImageUrl(notification, user);
    const highlight = i < unread;
    const title = truncate(notification.title, 68);

    const name = menuItem(notification, { username: username, title: title });

    return { name, link, imageUrl, highlight, username };
  });
};
